var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8387 21.9466H20.7532L22.6831 10.746H25.7685L23.8387 21.9466Z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0238 11.0198C34.4152 10.7932 33.4499 10.543 32.2564 10.543C29.2093 10.543 27.0636 12.0681 27.0505 14.2485C27.0251 15.8572 28.5867 16.7508 29.7546 17.2872C30.9484 17.8353 31.3542 18.193 31.3542 18.6816C31.342 19.432 30.3896 19.7778 29.5012 19.7778C28.2693 19.7778 27.6093 19.5995 26.6062 19.1821L26.1999 19.0031L25.7681 21.5174C26.4918 21.8268 27.8251 22.1015 29.2093 22.1135C32.4469 22.1135 34.5546 20.612 34.5796 18.2884C34.5919 17.0133 33.7673 16.0364 31.9896 15.238C30.9104 14.7255 30.2495 14.38 30.2495 13.8556C30.2622 13.3789 30.8085 12.8906 32.0267 12.8906C33.0298 12.8667 33.7668 13.093 34.3251 13.3195L34.6042 13.4384L35.0238 11.0198Z",
    fill: "#15195A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.547 10.746H42.9336L45.4228 21.9464H42.566C42.566 21.9464 42.2864 20.6595 42.1978 20.2663H38.2362C38.1217 20.564 37.5887 21.9464 37.5887 21.9464H34.3511L38.9343 11.6753C39.2518 10.9484 39.811 10.746 40.547 10.746ZM40.3569 14.8448C40.3569 14.8448 39.3791 17.3352 39.125 17.9786H41.6897C41.5628 17.4186 40.9785 14.7376 40.9785 14.7376L40.7628 13.7725C40.672 14.021 40.5407 14.3627 40.4521 14.5931C40.3921 14.7493 40.3517 14.8545 40.3569 14.8448Z",
    fill: "#15195A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3841 10.746H12.3484C13.0213 10.7696 13.5673 10.9722 13.7449 11.6875L14.8237 16.8332C14.8239 16.8337 14.824 16.8342 14.8242 16.8347L15.1544 18.3837L18.1761 10.746H21.4388L16.5889 21.9347H13.3261L10.5759 12.2024C9.62706 11.6817 8.54411 11.2629 7.33331 10.9723L7.3841 10.746Z",
    fill: "#15195A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.db7e0ff78540a194b05b8912287695c5.svg";
export { ForwardRef as ReactComponent };